import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateProjects } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const projectRoute: Routes = [
  {
    path: 'projects',
    loadComponent: () => import('@project/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateProjects],
    data: {
      title: 'Projetos',
      key: PageKey.PROJECTS
    }
  },
  {
    path: 'projects/:projectId',
    loadComponent: () => import('@project/pages/crud/crud.component').then(m => m.CrudProjectComponent),
    canActivate: [...authenticatedRouteGuards, canActivateProjects],
    runGuardsAndResolvers: 'pathParamsChange',
    data: {
      title: 'Projeto',
      key: PageKey.PROJECTS
    }
  }
];
